import { startsWith } from 'lodash';

export default (e: unknown): e is MouseEvent =>
  e instanceof UIEvent && startsWith(e.type, 'mouse');
